/**
 * @author TankNee 2020-08-17
 * simple audio recorder
 */

import React from "react";
import PropTypes from "prop-types";
import * as Helper from "../../utils/Helper";
import { PauseCircleTwoTone, SoundTwoTone } from "@ant-design/icons";
const componentState = {
    START_UP: 1,
    PAUSED: 3,
    PLAYING: 5,
};
class AudioPalyer extends React.Component {
    state = {
        currentState: componentState.START_UP,
    };
    componentDidMount() {
        this._audio.addEventListener("pause", () => {
            this.setState({
                currentState: componentState.PAUSED,
            });
        });
    }
    render() {
        return (
            <div className="row align-items-center" style={{ flexWrap: "nowrap", margin: "10px" }}>
                <audio controls hidden ref={(audio) => (this._audio = audio)}>
                    <source src={this.props.absolutePath ? this.props.src : Helper.convertToFileServerPath(this.props.src)} type="audio/mp3" />
                </audio>
                {[componentState.START_UP, componentState.PAUSED].includes(this.state.currentState) && (
                    <SoundTwoTone twoToneColor={"#B5D685"} style={{ fontSize: "30px", cursor: "pointer" }} onClick={this._handleAudioPlay.bind(this)} />
                )}
                {this.state.currentState === componentState.PLAYING && (
                    <PauseCircleTwoTone twoToneColor={"#F87550"} style={{ fontSize: "30px", cursor: "pointer" }} onClick={this._handleAudioStop.bind(this)} />
                )}
            </div>
        );
    }
    _handleAudioPlay() {
        this.setState(
            {
                currentState: componentState.PLAYING,
            },
            () => {
                this._audio.play();
            }
        );
    }
    _handleAudioStop() {
        this.setState(
            {
                currentState: componentState.PAUSED,
            },
            () => {
                this._audio.pause();
            }
        );
    }
}
AudioPalyer.propTypes = {
    src: PropTypes.string,
    absolutePath: PropTypes.bool,
    onRecordStart: PropTypes.func,
    onRecordEnd: PropTypes.func,
    onRecordError: PropTypes.func,
};
AudioPalyer.defaultProps = {
    onRecordStart: () => {},
    onRecordEnd: () => {},
    onRecordError: console.error,
    absolutePath: false,
};
export default AudioPalyer;
